import omitFn from "lodash/omit";
import transEnumsI18n from "./transEnumsI18n";
import type { Config } from "../type";
import type { EnumItem } from "@/services/common/type";
import { getT } from "@/utils/intlUtils";

const getObjectEnums = (config: Config, pointedEnum: EnumItem[] = []) => {
  const { omit = [], isAll } = config;

  const object: Record<string, unknown> = {};

  if (isAll) {
    const t = getT();
    object[""] = { text: t("全部") };
  }

  pointedEnum.forEach((item) => {
    const current = {
      text: transEnumsI18n(item.groupCode, item.value),
    };
    object[item.value] = current;
  });

  if (omit.length !== 0) {
    return omitFn(object, omit as string[]);
  }

  return object;
};

export default getObjectEnums;
